import {
  Box,
  Button,
  ButtonGroup,
  Heading,
  SidebarContent,
  SidebarPanel,
  SidebarPart,
  SidebarWithoutTransition,
  Stack,
  useLayout,
} from '@eleveo/components-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfigurationCard } from '../../components/configuration/ConfigurationCard';
import { ETLConfigurationType, SUPPORTED_INTEGRATIONS } from '../../components/configuration/types';
import { TEST_IDS } from '../../constants/dataTestIds';
import { useSearchNavigate } from '../../hooks/useSearchNavigate';

export const IntegrationsPickerSideBar: React.FC = () => {
  // Initialize in the default state, even though the previous Sidebar could have been expanded.
  useLayout({
    expanded: false,
  });

  const { navigateToNewIntegrationType, navigateToMyConfigurations } = useSearchNavigate();
  const { t } = useTranslation();

  const handleSideBarClose = () => {
    navigateToMyConfigurations();
  };

  return (
    <SidebarWithoutTransition onClose={handleSideBarClose} title={t('myConfigurations.create')}>
      <SidebarPanel>
        <SidebarPart>
          <ButtonGroup>
            <Button disabled color="success" testId={TEST_IDS.buttonSaveIntegration}>
              {t('myConfigurations.save')}
            </Button>
            <Button
              color="warning"
              variant="outline"
              onClick={handleSideBarClose}
              testId={TEST_IDS.buttonCancelIntegration}
            >
              {t('myConfigurations.cancel')}
            </Button>
          </ButtonGroup>
        </SidebarPart>
      </SidebarPanel>
      <SidebarContent>
        <SidebarPart>
          <Box padding={20}>
            <Heading
              as="h3"
              className="text-2xl text-blue-700 font-bold mb-25"
              testId={TEST_IDS.headingConfigurationPickerTitle}
            >
              {t('myConfigurations.chooseType')}
            </Heading>

            <Stack direction="vertical" className="w-full" spacing={25}>
              {SUPPORTED_INTEGRATIONS.map((integration) => (
                <ConfigurationCard<ETLConfigurationType>
                  isSmall
                  testId={TEST_IDS.buttonConfigurationPickerCard(integration)}
                  key={integration}
                  configuration={{ integration }}
                  onClick={() => {
                    navigateToNewIntegrationType(integration);
                  }}
                />
              ))}
            </Stack>
          </Box>
        </SidebarPart>
      </SidebarContent>
    </SidebarWithoutTransition>
  );
};
